import DefaultLayout from '@/components/Layouts/DefaultLayout';
import { AppPropsWithLayout } from '@/interfaces/common';
import '@/styles/globals.css';
import { Fragment } from 'react';
import localFont from 'next/font/local';
import { SpeedInsights } from '@vercel/speed-insights/next';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const gilroy = localFont({
  src: [
    {
      path: '../../public/fonts/SVN-GilroyBlack.otf',
      weight: '900',
    },
    {
      path: '../../public/fonts/SVN-GilroyBold.otf',
      weight: '700',
    },
    {
      path: '../../public/fonts/SVN-GilroyHeavy.otf',
      weight: '800',
    },
    {
      path: '../../public/fonts/SVN-GilroyLight.otf',
      weight: '200',
    },
    {
      path: '../../public/fonts/SVN-GilroyMedium.otf',
      weight: '500',
    },
    {
      path: '../../public/fonts/SVN-GilroyRegular.otf',
      weight: '400',
    },
    {
      path: '../../public/fonts/SVN-GilroySemiBold.otf',
      weight: '600',
    },
    {
      path: '../../public/fonts/SVN-GilroyThin.otf',
      weight: '300',
    },
  ],
  variable: '--font-gilroy',
});

export default function App({ Component, pageProps }: AppPropsWithLayout) {
  const Layout =
    Component.Layout === null ? Fragment : Component.Layout ?? DefaultLayout;
  return (
    <main className={`${gilroy.variable} font-sans`}>
      <Layout>
        <Component {...pageProps} />
        <SpeedInsights />
      </Layout>
    </main>
  );
}
